// Loading placeholders in the shape of what is coming. `.skeleton` pulses (not under reduced motion).
export const SkeletonBlock = ({className = ''}: {className?: string}) => <div aria-hidden className={`skeleton ${className}`} />;

export function SkeletonCard() {
    return (
        <div className="card overflow-hidden" aria-hidden>
            <SkeletonBlock className="h-[196px] w-full rounded-none" />
            <div className="flex flex-col gap-2 p-4">
                <SkeletonBlock className="h-5 w-3/4" />
                <SkeletonBlock className="h-4 w-1/2" />
            </div>
        </div>
    );
}

export function SkeletonRow() {
    return (
        <div className="flex items-center gap-3 py-3" aria-hidden>
            <SkeletonBlock className="h-12 w-12 shrink-0 rounded-[12px]" />
            <div className="flex flex-1 flex-col gap-2">
                <SkeletonBlock className="h-4 w-2/3" />
                <SkeletonBlock className="h-3 w-1/3" />
            </div>
        </div>
    );
}

export function SkeletonList({rows = 4, kind = 'row'}: {rows?: number; kind?: 'row' | 'card'}) {
    return (
        <div role="status" aria-label="Loading" className={kind === 'card' ? 'flex flex-col gap-4' : 'rows'}>
            {Array.from({length: rows}, (_, i) => (kind === 'card' ? <SkeletonCard key={i} /> : <SkeletonRow key={i} />))}
        </div>
    );
}
